import { useCreateAccount, useUpdateCoreProfile } from "./profile";
import { useGetStateEligibility } from "./sequence";
import useLoggedInDataHandler from "./useLoggedInDataHandler";
import {
  FIRST_NAME,
  LAST_NAME,
  MEDICAL,
  STATE,
  EMAIL,
  PASSWORD,
  PHONE_NUMBER,
  MAILING_ADDRESS,
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  CITY,
  ZIPCODE,
  STATE_NEXT_STEP_PAGE,
  OPTIN
} from "../components/Profile/constants";
import { STATE_UNSERVICEABLE, STATE_HOTSPOT } from "./eligibility";
import { setPageData } from "./analytics";

const useAsyncPagesHandler = ({
  question,
  profile,
  updateProfile,
  authData,
  setAuthData
}) => {
  const {
    trigger: createAccountTrigger,
    isMutating: createAccountIsLoading,
    error: createAccountError
  } = useCreateAccount();
  const {
    trigger: updateCoreProfileTrigger,
    isMutating: updateCoreProfileIsLoading
  } = useUpdateCoreProfile();
  const { getLoggedInData, getLoggedInDataIsLoading } = useLoggedInDataHandler({
    authData,
    setAuthData
  });
  const {
    trigger: getStateEligibilityTrigger,
    isMutating: getStateEligibilityIsLoading
  } = useGetStateEligibility();

  const handleAsyncPages = async () => {
    const { isAccountCreation, isPhoneNumberUpdate, isRegionUpdate } =
      question || {};
    let proceed = true;

    switch (true) {
      case isAccountCreation: {
        const response = await createAccountTrigger({
          email: profile[MEDICAL][EMAIL],
          password: profile[PASSWORD],
          firstname: profile[FIRST_NAME],
          lastname: profile[LAST_NAME],
          optin: profile[OPTIN]
        });
        if (response?.data?.success) {
          updateProfile(PASSWORD, "");
          setPageData({
            site_section: "clinical",
            user_newly_registered: true
          });
          await getLoggedInData();
        } else {
          proceed = false;
        }
        break;
      }
      case isPhoneNumberUpdate: {
        await updateCoreProfileTrigger({
          firstName: profile[FIRST_NAME],
          lastName: profile[LAST_NAME],
          street1: profile[MAILING_ADDRESS][ADDRESS_LINE_1],
          street2: profile[MAILING_ADDRESS][ADDRESS_LINE_2],
          city: profile[MAILING_ADDRESS][CITY],
          region: profile[MAILING_ADDRESS][STATE],
          postalCode: profile[MAILING_ADDRESS][ZIPCODE],
          phone: profile[PHONE_NUMBER]
        });
        break;
      }
      case isRegionUpdate: {
        const response = await getStateEligibilityTrigger();
        const stateCapacity = response?.data?.stateCapacity;
        let stateNextStepPage = "";
        if (stateCapacity) {
          const selectedStateCapacity =
            stateCapacity?.[profile[MAILING_ADDRESS][STATE]];
          if (!selectedStateCapacity) {
            stateNextStepPage = STATE_UNSERVICEABLE;
          } else if (selectedStateCapacity.isHotSpot) {
            stateNextStepPage = STATE_HOTSPOT;
          }
        }
        updateProfile(STATE_NEXT_STEP_PAGE, stateNextStepPage);
        proceed = !stateNextStepPage;
        break;
      }
      default: {
        break;
      }
    }

    return proceed;
  };

  return {
    handleAsyncPages,
    callIsPending:
      createAccountIsLoading ||
      updateCoreProfileIsLoading ||
      getLoggedInDataIsLoading ||
      getStateEligibilityIsLoading,
    createAccountError
  };
};

export default useAsyncPagesHandler;
